export default [{
  name: "Do Not Rent List",
  path: '/do-not-rent',
  component: () => import('../components/do_not_rent/index.vue'),
  meta: {
    requiresAuth: true,
    hasAccess: ['admin'],
    layout: 'master',
    re_fetch:true
  }
}]